import React from "react";
import Footer from "../components/Footer";
import AboutUs from "../components/AboutUs";

function About() {
    
    return (
        <React.Fragment>
            <AboutUs/>
            <Footer />
        </React.Fragment>
    )
}

export default About